import React from "react";
import CardHeader from "../../../components/atoms/cardHeader";
import { Col, DatePicker, Form, Row } from "antd";
import { ContentInputField } from "../../../components/atoms/formFields/inputField/contentInputField";
import SelectOption from "../../../components/atoms/formFields/selectOption";
import moment from "moment/moment";
import BottomRightButton from "../../../components/atoms/formFields/buttons/bottomRightButton";
import { BrandDropdown } from "../../../components/atoms/brand";
import dayjs from "dayjs";

const InventoryFilter = ({ pagination, setPagination }) => {
  return (
    <div className="filter_area collapse" id="filter">
      <Form>
        <div className="container">
          <CardHeader name="Inventory Filter" />
          <div className="bg-white mb-10 p-5 radius-bottom" id="ant_inputs">
            <Row gutter={[12, 12]}>
              <Col className="gutter-row" xs={24} lg={6}>
                <ContentInputField
                  name="Product Name"
                  value={pagination?.productName}
                  onChange={(e) => {
                    setPagination({
                      ...pagination,
                      productName: e.target.value,
                      paginationFilter: {
                        ...pagination.paginationFilter,
                        offset: 0,
                      },
                    });
                  }}
                />
              </Col>
              <Col className="gutter-row" xs={24} lg={6}>
                <ContentInputField
                  name="SKU"
                  value={pagination?.sku}
                  onChange={(e) => {
                    setPagination({
                      ...pagination,
                      sku: e.target.value,
                      paginationFilter: {
                        ...pagination.paginationFilter,
                        offset: 0,
                      },
                    });
                  }}
                />
              </Col>

              <Col className="gutter-row" xs={24} lg={6}>
                <SelectOption
                  placeholder="Product Type"
                  value={
                    pagination?.productType
                      ? {
                          label: pagination?.productType,
                          value: pagination?.productType,
                        }
                      : []
                  }
                  isClearable={true}
                  options={[
                    { label: "Simple", value: "SIMPLE" },
                    { label: "Variable", value: "VARIABLE" },
                  ]}
                  onChange={(val) => {
                    if (val) {
                      setPagination({
                        ...pagination,
                        productType: val.value,
                        paginationFilter: {
                          ...pagination.paginationFilter,
                          offset: 0,
                        },
                      });
                    } else {
                      setPagination({
                        ...pagination,
                        productType: "",
                        paginationFilter: {
                          ...pagination.paginationFilter,
                          offset: 0,
                        },
                      });
                    }
                  }}
                />
              </Col>

              <Col className="gutter-row" xs={24} lg={6}>
                <SelectOption
                  placeholder="Stock Status"
                  value={
                    pagination?.stockStatus
                      ? {
                          label: pagination?.stockStatus,
                          value: pagination?.stockStatus,
                        }
                      : []
                  }
                  isClearable={true}
                  options={[
                    { label: "In Stock", value: "IN_STOCK" },
                    { label: "Out of Stock", value: "OUT_OF_STOCK" },
                    // {
                    //   label: "Pending verification",
                    //   value: "PENDING_VERIFICATION",
                    // },
                  ]}
                  onChange={(val) => {
                    if (val) {
                      setPagination({
                        ...pagination,
                        stockStatus: val.value,
                        paginationFilter: {
                          ...pagination.paginationFilter,
                          offset: 0,
                        },
                      });
                    } else {
                      setPagination({
                        ...pagination,
                        stockStatus: null,
                        paginationFilter: {
                          ...pagination.paginationFilter,
                          offset: 0,
                        },
                      });
                    }
                  }}
                />
              </Col>

              <Col className="gutter-row" xs={24} lg={6}>
                <BrandDropdown
                  isClearable={true}
                  value={pagination?.brandId}
                  onChange={(val) => {
                    if (val) {
                      setPagination({
                        ...pagination,
                        brandId: val.value,
                        paginationFilter: {
                          ...pagination.paginationFilter,
                          offset: 0,
                        },
                      });
                    } else {
                      setPagination({
                        ...pagination,
                        brandId: "",
                        paginationFilter: {
                          ...pagination.paginationFilter,
                          offset: 0,
                        },
                      });
                    }
                  }}
                />
              </Col>

              <Col className="gutter-row" xs={24} lg={6}>
                <label className="font-weight-bolder font-size-sm">
                  Published date
                </label>
                <DatePicker
                  className="form-control"
                  disabledDate={(current) => {
                    return moment().add(0, "days") <= current;
                  }}
                  format={"DD/MM/YYYY"}
                  value={
                    pagination?.publishedDate &&
                    dayjs(pagination?.publishedDate, "DD/MM/YYYY")
                  }
                  onChange={(value) => {
                    if (value) {
                      setPagination({
                        ...pagination,
                        publishedDate: moment(value["$d"]).format("DD/MM/YYYY"),
                        paginationFilter: {
                          ...pagination.paginationFilter,
                          offset: 0,
                        },
                      });
                    } else {
                      setPagination({
                        ...pagination,
                        publishedDate: "",
                        paginationFilter: {
                          ...pagination.paginationFilter,
                          offset: 0,
                        },
                      });
                    }
                  }}
                />
              </Col>

              <Col className="gutter-row" xs={24} lg={12}>
                <p className="m-0">&nbsp;</p>
                <BottomRightButton
                  name="Reset"
                  onClick={() => {
                    setPagination({
                      inventoryId: pagination?.inventoryId,
                      paginationFilter: {
                        ...pagination.paginationFilter,
                        offset: 0,
                      },
                    });
                  }}
                />
              </Col>
            </Row>
          </div>
        </div>
      </Form>
    </div>
  );
};
export default InventoryFilter;
